import { SpinResponse } from '@cgs/data-access';
import { Container } from '@cgs/wge';
import { IconModel } from '../../game/components/icon_model';
import { CollapseReelsEngine } from '../collapse_reel_engine/collapse_reel_engine';
import { ComponentIndex } from '../entities_engine/component_index';
import { EntitiesEngine } from '../entities_engine/entities_engine';
import { ComponentNames } from '../entity_components/component_names';
import { IReelsConfig } from '../i_reels_config';
import { IconEnumerator } from '../icon_enumerator';
import { IconsSceneObject } from '../icons_scene_object';
import { ReelsSoundModel } from '../reels_sound_model';
import { GameStateMachine } from '../state_machine/game-state-machine';
import { AfterAccelerationSystem } from './systems/after_acceleration_system';
import { FreeFallBeforeBrakingSystem } from './systems/free_fall_before_braking_system';
import { FreeFallMovementSystem } from './systems/free_fall_movement_system';

export class FreeFallReelsEngine extends CollapseReelsEngine {
  private _acceleratedReels: number[] = [];

  constructor(
    container: Container,
    entityEngine: EntitiesEngine,
    iconRender: IconsSceneObject,
    animIconRender: IconsSceneObject,
    iconModel: IconModel,
    enumerator: IconEnumerator,
    reelConfig: IReelsConfig,
    gameStateMachine: GameStateMachine<SpinResponse>,
    reelsSoundModel: ReelsSoundModel,
    useSounds: boolean
  ) {
    super(
      container,
      entityEngine,
      iconRender,
      animIconRender,
      iconModel,
      enumerator,
      reelConfig,
      gameStateMachine,
      reelsSoundModel,
      useSounds
    );
  }

  get isSlotAccelerated(): boolean {
    return this._acceleratedReels.length === this.ReelConfig.reelCount;
  }

  createSystems(): void {
    super.createSystems();
    this.movementSystem.unregister();

    this.movementSystem = new FreeFallMovementSystem(
      this.entityEngine,
      this.entityCacheHolder
    ).withInitialize();

    this.movementSystem.updateOrder = 600;
    this.movementSystem.register();

    const freeFallAccelerationSystem = new AfterAccelerationSystem(
      this.entityEngine,
      this.entityCacheHolder,
      this.internalConfig,
      [this.entityEngine.getComponentIndex(ComponentNames.RelocatedFlag)]
    ).withInitialize();

    freeFallAccelerationSystem.reelFalled.listen((reel) => this.onReelFalled(reel));
    freeFallAccelerationSystem.updateOrder = 701;
    freeFallAccelerationSystem.register();

    const indexesForFilter: ComponentIndex[] = [
      this.entityEngine.getComponentIndex(ComponentNames.BrakingCalculationInfo),
      this.entityEngine.getComponentIndex(ComponentNames.ReelIndex),
    ];
    const freeFallBrakingSystem = new FreeFallBeforeBrakingSystem(
      this.entityEngine,
      this.entityCacheHolder,
      this.internalConfig,
      this.iconsEnumerator,
      indexesForFilter
    ).withInitialize();

    this.beforeBrakingSystem.unregister();
    freeFallBrakingSystem.updateOrder = 701;
    freeFallBrakingSystem.register();
  }

  private onReelFalled(reel: number): void {
    if (!this._acceleratedReels.includes(reel)) {
      this._acceleratedReels.push(reel);
    }

    super.onReelAccelerated(reel);
  }

  onEntityStopped(position: number[]): void {
    this._acceleratedReels = [];
    super.onEntityStopped(position);
  }
}
